import {
  forwardRef,
  ForwardRefExoticComponent,
  KeyboardEvent,
  PropsWithChildren,
  FocusEvent,
  RefAttributes,
} from 'react';
import cns from 'classnames';

import { ReactComponent as CheckedCheckboxIcon } from './checked.svg';
import styles from './Checkbox.module.scss';

export interface ICheckboxProps extends RefAttributes<HTMLInputElement> {
  checked: boolean;
  className?: string;
  onChange: (value: boolean) => void;
  onBlur?: (event?: FocusEvent<HTMLElement>) => void;
  onFocus?: (event?: FocusEvent<HTMLElement>) => void;
  disabled?: boolean;
}

const Checkbox: ForwardRefExoticComponent<PropsWithChildren<ICheckboxProps>> = forwardRef(
  ({ checked,className, onChange, children, disabled, ...rest }, ref) => {
    const handleClick = () => {
      onChange(!checked);
    };
    const handleKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case ' ':
          onChange(!checked);
          break;
      }
    };
    return (
      <div
        className={cns(styles.wrapper, className, {
          [styles.disabled]: disabled,
        })}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        {...rest}
        ref={ref}
      >
        <div className={styles.icon} onClick={handleClick}>
          {checked ? <CheckedCheckboxIcon /> : <div className={styles.empty} />}
        </div>
        {children && (
          <div className={styles.label} onClick={handleClick}>
            {children}
          </div>
        )}
      </div>
    );
  }
);

export default Checkbox;
